module.exports = __webpack_public_path__ + "img/list-ul-solid.b37880cb.svg";